import Vue from 'vue'
import VueRouter from 'vue-router';
import App from './App.vue'
import { Amplify } from 'aws-amplify';
import '@aws-amplify/ui-vue';
import aws_exports from './aws-exports';
import vuetify from './plugins/vuetify';
import router from './router';
import store from "./store";

Amplify.configure(aws_exports);

Vue.use(VueRouter);
Vue.config.productionTip = false;

new Vue({
  // el: '#app',
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app');
